<template>
    <Modal id="upgrade-needed" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="content">
            <div class="title">Ekstra Chatbot Satın Al</div>
            <div class="subtitle">Session Seçiniz</div>
            <div class="suggestion-sessions">
                <div class="suggestion-item" :class="[sessionCount == 1000 && 'selected']" @click="sessionCount = 1000">
                    1000
                </div>
                <div class="suggestion-item" :class="[sessionCount == 5000 && 'selected']" @click="sessionCount = 5000">
                    5000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 10000 && 'selected']"
                    @click="sessionCount = 10000"
                >
                    10000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 20000 && 'selected']"
                    @click="sessionCount = 20000"
                >
                    20000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 50000 && 'selected']"
                    @click="sessionCount = 50000"
                >
                    50000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 100000 && 'selected']"
                    @click="sessionCount = 100000"
                >
                    100000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 250000 && 'selected']"
                    @click="sessionCount = 250000"
                >
                    250000
                </div>
                <div
                    class="suggestion-item"
                    :class="[sessionCount == 1000000 && 'selected']"
                    @click="sessionCount = 1000000"
                >
                    1000000
                </div>
            </div>
            <div class="result-chatbot">
                <div class="session-count">
                    <a-input-number v-model="sessionCount" :min="1" :max="10000000" />
                </div>
                <div class="material-icons">arrow_forward</div>
                <MoneyFormatter :price="totalPrice" :className="total - price" />
            </div>
            <div class="footer">
                <div class="subbutton" @click="confirm">Buy now</div>
                <div class="cancel-b" @click="cancel">Cancel</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import CreditCardNeeded from "../svg/CreditCardNeeded.vue";
import _ from "lodash";
import { mapState } from "vuex";
import MoneyFormatter from "../MoneyFormatter.vue";

const sessionAndPricing = [
    [300, 2],
    [500, 1.2],
    [1000, 1],
    [5000, 0.6],
    [10000, 0.55],
    [20000, 0.45],
    [50000, 0.4],
    [100000, 0.35],
    [250000, 0.3],
    [500000, 0.25],
    [1000000, 0.2],
];

export default {
    name: "ExtraPlanModal",
    props: {
        period: {
            type: String,
            default: "monthly",
        },
    },
    components: {
        Modal,
        CreditCardNeeded,
        MoneyFormatter,
    },
    data: () => ({
        sessionCount: 0,
        totalPrice: 0,
        timeout: null,
    }),
    methods: {
        cancel() {
            this.$emit("close");
        },
        confirm() {
            this.$emit("confirm", parseInt(this.sessionCount));
        },
        calculateSessionPrice() {
            const sessionCount = this.sessionCount;
            const isLastSession = sessionCount > sessionAndPricing[sessionAndPricing.length - 1][0];
            const x2Index = sessionAndPricing.findIndex(
                (session) => session[0] >= sessionCount && sessionCount <= session[0]
            );
            const x1Index = Math.max(x2Index - 1, 0);
            const [x1, y1] = sessionAndPricing[isLastSession ? sessionAndPricing.length - 1 : x1Index];
            const [x2, y2] = sessionAndPricing[isLastSession ? sessionAndPricing.length - 1 : x2Index];
            return (y1 + ((sessionCount - x1) * (y2 - y1)) / Math.max(x2 - x1, 1)) * sessionCount;
        },
    },
    watch: {
        sessionCount() {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.totalPrice = this.calculateSessionPrice();
            }, 200);
        },
    },
};
</script>
<style></style>
<style lang="scss">
#upgrade-needed {
    width: 80vw;
    .ant-modal {
        width: 600px !important;
    }
    .suggestion-sessions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        flex-wrap: wrap;
        .suggestion-item {
            padding: 5px 10px;
            border: 1px solid #dddddd;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
            &.selected {
                background-color: rgb(236, 75, 29);
                color: white;
            }
        }
    }
    .subtitle {
        font-size: 16px;
        font-weight: bold;
    }
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .upgrade-svg {
            width: 100%;
            height: 100%;

            svg {
                width: 50%;
                height: 40%;
            }
        }

        .title {
            font-size: 26px;
            font-weight: bold;
            margin-top: 10px;
            margin-bottom: 20px;
        }

        .description {
            font-size: 16px;
        }

        .subbutton {
            padding: 10px 30px;
            background: rgb(236, 75, 29);
            border-radius: 99px;
            font-size: 16px;
            cursor: pointer;
            color: white;
            margin-top: 15px;
        }
        .result-chatbot {
            display: flex;
            align-items: center;
            gap: 30px;
            margin-top: 15px;
            input {
                border: none;
                padding: 5px 20px;
                max-width: 100px;
                -moz-appearance: textfield;
                border-radius: 4px;
                &::-webkit-inner-spin-button,
                &::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
            }
            .material-icons {
                font-weight: bold;
            }
            .total-price {
                font-weight: bold;
                font-size: 18px;
            }
        }
        .footer {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            margin-top: 10px;
            .cancel-b {
                font-size: 14px;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
}
</style>
